export const CONTAINER_MOBILE_MARGIN = 16;
export const CONTAINER_DESKTOP_MARGIN = 24;
export const CONTAINER_MAX_WIDTH = 1680;